import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Router } from '@angular/router';
import { ResolutionOrdersService } from 'src/app/services/resolution-orders.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Constants } from 'src/app/constants';
import { CommonConstant } from '../../constant/common.constant';
import { AetStateService } from 'src/app/services/aet-state.service';

@Component({
  selector: 'app-edit-btn-renderer',
  templateUrl: './edit-btn-renderer.component.html',
  styleUrls: ['./edit-btn-renderer.component.scss'],
  standalone: false // NOSONAR
})
export class EditBtnRendererComponent implements ICellRendererAngularComp {

  resolutionId: any;
  editCheck: boolean = true;
  errorMessage: any;
  isAccessible: boolean = true;
  refresh(params: ICellRendererParams): boolean {
    throw new Error(
      `Error while refreshing renderer component. INFO-${params}`
    );
  }

  protected params: any;
  constructor(private readonly router: Router, private readonly resolutionOrdersService: ResolutionOrdersService,
    private readonly ngxUiLoaderService: NgxUiLoaderService, private readonly constants: Constants, private readonly aetStateService: AetStateService
  ) { }

  agInit(params: any): void {
    // this.checkRoles();
    this.params = params;

    this.resolutionId = this.params.data.resolution_id;
    this.resolutionOrdersService.getCountOrders(this.resolutionId).subscribe({
      next: (res: any) => {
        this.ngxUiLoaderService.stop(CommonConstant.loader);
        if (res.ordersSize > 0) {
          this.editCheck = true;
        }
        else if (this.router.url.includes('/dashboard/resolutions')) {
          this.editCheck = true;
        }
        else {
          this.editCheck = false;
        }
      }


      ,
      error: (_error) => {
        this.ngxUiLoaderService.stop(CommonConstant.loader);
        this.errorMessage = this.constants.APIErrorMessage;
      }
    })


  }

  async checkRoles() {
    await this.aetStateService.getRoles();
    const roles = this.aetStateService.getroleState();
    const userRoles = JSON?.parse(roles);
    if (userRoles && (userRoles.includes(this.constants.LIOS_UAC_Admin) || userRoles.includes(this.constants.LIOS_UAC_LP_Filter) ||
      userRoles.includes(this.constants.LIOS_UAC_TEMA_Ops) || userRoles.includes(this.constants.LIOS_UAC_NAMC_Planner) ||
      userRoles.includes(this.constants.LIOS_UAC_AET_LP) || userRoles.includes(this.constants.LIOS_UAC_MTMUS_Planner)
      || userRoles.includes(this.constants.LIOS_UAC_MTMUS_Negotiator) || userRoles.includes(this.constants.LIOS_UAC_Portal_Administrator)
      || userRoles.includes(this.constants.LIOS_UAC_Reporting_Admin) || userRoles.includes(this.constants.LIOS_UAC_Reporting_User)
      || userRoles.includes(this.constants.LIOS_UAC_Route_Planner) || userRoles.includes(this.constants.LIOS_UAC_SCV_Admin)
      || userRoles.includes(this.constants.LIOS_UAC_Security_Admin) || userRoles.includes(this.constants.LIOS_UAC_TEMA_AF)
      || userRoles.includes(this.constants.LIOS_UAC_TEMA_Budgeting) || userRoles.includes(this.constants.LIOS_UAC_TEMA_OPS_AM)
      || userRoles.includes(this.constants.LIOS_UAC_TEMA_OPS_Specialist) || userRoles.includes(this.constants.LIOS_UAC_TEMA_Purchasing)
      || userRoles.includes(this.constants.LIOS_UAC_TEMA_LC) || userRoles.includes(this.constants.LIOS_UAC_TPT_Admin)
      || userRoles.includes(this.constants.LIOS_UAC_TSCS_Admin) || userRoles.includes(this.constants.LIOS_UAC_WT_Administrator))) {
      this.isAccessible = true;
    }
    else {
      this.isAccessible = false;
    }
    // if (userRoles && userRoles.includes(this.constants.LIOS_UAC_Admin) || userRoles.includes(this.constants.LIOS_UAC_LP_Filter ||
    //   userRoles.includes(this.constants.LIOS_UAC_TEMA_Ops) || userRoles.includes(this.constants.LIOS_UAC_TaskManagerUser)) {
    //   // this.isAccessible = true;
    // } else {
    //   this.router.navigate([`/home`]);
    // }
  }

  resolutionOrders() {
    if (this.params.keyParam == true) {    // NOSONAR
      this.params.context.componentParent.navEditResolutions(this.params.data);
    } else {
      this.router.navigate(['/history/resolutions/resolution-orders']);
      this.resolutionId = this.params.data.resolution_id;
      localStorage.setItem('resolutionId', this.resolutionId);
    }

  }

}
